module.exports = {
          srcSet: __webpack_public_path__ + "f82416e5.png"+" 45w",
          images:[ {path: __webpack_public_path__ + "f82416e5.png",width: 45,height: 45}],
          src: __webpack_public_path__ + "f82416e5.png",
          toString:function(){return __webpack_public_path__ + "f82416e5.png"},
          
          width: 45,
          height: 45
        }